import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = ({ onNavigate, onOpenApplicationInquiry }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (page) => {
    if (onNavigate) onNavigate(page);
    setMobileMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-logo" onClick={() => handleNav('home')}>
          <img src="/logotkmb.png" alt="TKMB" className="navbar-logo-img" />
        </div>

        <div className={`navbar-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <a href="#anasayfa" onClick={(e) => { e.preventDefault(); handleNav('home'); }}>Ana Sayfa</a>
          <a href="#hakkimizda" onClick={(e) => { e.preventDefault(); handleNav('about'); }}>Hakkımızda</a>
          <a href="#uyelik" onClick={(e) => { e.preventDefault(); handleNav('membership'); }}>Üyelik</a>
          <a href="#standartlar" onClick={(e) => { e.preventDefault(); handleNav('standards'); }}>Mesleki Standartlar</a>
          <a href="#sanayi" onClick={(e) => { e.preventDefault(); handleNav('industry'); }}>Sanayi İş Birlikleri</a>
          <a href="#tuzuk" onClick={(e) => { e.preventDefault(); handleNav('bylaws'); }}>Tüzük</a>
          <a href="#iletisim" onClick={(e) => { e.preventDefault(); handleNav('contact'); }}>İletişim</a>
          {onOpenApplicationInquiry && (
            <button type="button" className="navbar-inquiry-btn navbar-inquiry-mobile" onClick={(e) => { e.preventDefault(); onOpenApplicationInquiry(); setMobileMenuOpen(false); }}>
              Başvuru Sorgula
            </button>
          )}
          <button type="button" className="navbar-cta-btn navbar-menu-cta" onClick={() => handleNav('membership-form')}>
            Online Başvuru
          </button>
        </div>

        <div className="navbar-right">
          {onOpenApplicationInquiry && (
            <button type="button" className="navbar-inquiry-btn" onClick={onOpenApplicationInquiry}>
              Başvuru Sorgula
            </button>
          )}
          <button type="button" className="navbar-cta-btn" onClick={() => handleNav('membership-form')}>
            Online Başvuru
          </button>
        </div>

        <button className="mobile-menu-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Menü">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
